import { PureComponent } from 'react';

export class Hotjar extends PureComponent {
  componentDidMount() {
    // Set your APP_ID
    const APP_ID = process.env.HOTJAR_SITE_ID;

    /* eslint-disable */
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:APP_ID,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    /* eslint-enable */
  }

  render() {
    return null;
  }
}
